
<div class="grid" *ngIf="!cargaInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="cargaInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <h1 class="titulo-pagina">{{ 'SOLICITUDBLOQUEOSARLAFT.LBL_SOLICITUDBLOQUEOSARLAFT' | translate }}</h1>
    </div>
  </div>

  <div *ngIf="errorConfiguracion">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12 text-center" style="background-color: red; border-radius: 8px; color: #fff;">
        {{ 'MSG_FALTACONFIGURACION' | translate }}
      </div>
    </div>
  </div>

  <div *ngIf="!errorConfiguracion">
    <div class="grid contenedor-filtros" id="filter-container">
      <div class="col-12">
        <form [formGroup]="formBusqueda" (ngSubmit)="filter()">
          <div class="grid form-group">
            <div class="col-3 md:col-3 lg:col-3">
              <div class="div-form">
                <label>{{ 'SOLICITUDBLOQUEOSARLAFT.LBL_NUMEROSOLICITUD' | translate }}</label>
                <input type="number" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                       buscador formControlName="codigoSolicitud">
              </div>
            </div>

            <div class="col-3 md:col-3 lg:col-3">
              <div class="div-form">
                <label>{{ 'SOLICITUDBLOQUEOSARLAFT.LBL_CODIGOSHIVAM' | translate }}</label>
                <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                       buscador formControlName="codigoShivam">
              </div>
            </div>

            <div class="col-3 md:col-3 lg:col-3">
              <div class="div-form">
                <label>{{ 'SOLICITUDBLOQUEOSARLAFT.LBL_NUMERODOCUMENTO' | translate }}</label>
                <input type="number" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                       buscador formControlName="numeroDocumento">
              </div>
            </div>

            <div class="col-3 md:col-3 lg:col-3">
              <div class="div-form">
                <label>{{ 'SOLICITUDBLOQUEOSARLAFT.LBL_NOMBRETERCERO' | translate }}</label>
                <p-autoComplete placeholder="{{ 'LBL_BUSCAR' | translate}}" field="nombreCompleto" name="nombreTercero" id="idTercero"
                                formControlName="tercero"
                                autocomplete="off"
                                [suggestions]="listaTerceros"
                                [forceSelection]="true"
                                (completeMethod)="buscarAutocomplete($event, 'TER')"
                                (onClear)="limpiarAutocomplete('TER')"
                                (onSelect)="capturar($event,'TER')"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                showEmptyMessage="true">
                </p-autoComplete>
              </div>
            </div>
          </div>

          <div class="grid form-group">
            <div class="col-4 md:col-4 lg:col-4">
              <div class="div-form">
                <label>{{ 'SOLICITUDBLOQUEOSARLAFT.LBL_NOMBREOFICINA' | translate }}</label>
                <p-dropdown disableTab  id="idEstructuraFisica" name="idEstructuraFisica" [options]="listaOficinas"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label" filter="filter"
                             formControlName="idEstructuraFisica"
                ></p-dropdown>
              </div>
            </div>

            <div class="col-4 md:col-4 lg:col-4">
              <div class="div-form">
                <label>{{ 'SOLICITUDBLOQUEOSARLAFT.LBL_FECHAINICIAL' | translate }}</label>
                <p-calendar #fechaInicial id="fechaInicial" [showButtonBar]="true" name="fechaInicial" [showIcon]="true"
                            [showTime]="false" formControlName="fechaInicial"
                            [monthNavigator]="true" [yearNavigator]="true"
                            readonlyInput="true" [maxDate]="maxFecha"
                            dataType="date" yearRange="{{calendarProperties.rango}}" [locale]="calendarProperties.informacion"
                            dateFormat="yy'-'mm'-'dd"
                            placeholder="{{'SOLICITUDBLOQUEOSARLAFT.LBL_FECHAINICIAL' | translate}}">
                </p-calendar>
              </div>
            </div>

            <div class="col-4 md:col-4 lg:col-4">
              <div class="div-form">
                <label>{{ 'SOLICITUDBLOQUEOSARLAFT.LBL_FECHAFINAL' | translate }}</label>
                <p-calendar #fechaFinal id="fechaFinal" [showButtonBar]="true" name="fechaFinal" [showIcon]="true"
                            [showTime]="false" formControlName="fechaFinal"
                            [monthNavigator]="true" [yearNavigator]="true"
                            readonlyInput="true" [maxDate]="maxFecha"
                            dataType="date" yearRange="{{calendarProperties.rango}}" [locale]="calendarProperties.informacion"
                            dateFormat="yy'-'mm'-'dd"
                            placeholder="{{'SOLICITUDBLOQUEOSARLAFT.LBL_FECHAFINAL' | translate}}">
                </p-calendar>
              </div>
            </div>
          </div>

          <div class="grid form-footer-buttons" *ngIf="!buscando">
            <div class="form-group col-12 flex align-items-center gap-2">
              <button type="button" pButton class="p-button-secondary mt-2" icon="fa fa-eraser"
                      (click)="limpiar()"
                      label="{{ 'BTN_LIMPIAR' | translate}}"></button>
              <button type="submit" icon="fa fa-search" class="p-button p-button-success btn mt-2" data-toggle="tooltip"
                      title="{{'BTN_BUSCAR' | translate}}" label="{{'BTN_BUSCAR' | translate}}"
                      pButton></button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12 px-0">
        <p-table [lazy]="true"
                 [totalRecords]="numRegistros" #dt
                 (onLazyLoad)="buscar($event)"
                 [columns]="columnas" [loading]="buscando"
                 [value]="listaSolicitudesBloqueo"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td class="text-center">{{row.codigoShivam ? row.codigoShivam: 'Falta codigo shivam'}}</td>
              <td class="text-center">{{row.numeroDocumentoTerceroSolicitante ? row.numeroDocumentoTerceroSolicitante: 'Falta número documento'}}</td>
              <td class="text-center">{{row.nombreTerceroSolicitante ? row.nombreTerceroSolicitante : 'Falta nombre cliente'}}</td>
              <td class="text-center">{{row.oficina ? row.oficina : 'Falta nombre oficina'}}</td>
              <td class="text-center">{{row.fechaSolicitud | date:'yyyy-MM-dd'}}</td>
              <td class="text-center">
                <div>
                  <div class="btn-group" role="group">
                    <div [hidden]="cargandoInfoSolicitud">
                      <button type="button" class="p-button btn" icon="fa fa-cogs" data-toggle="tooltip"
                              title="{{'SOLICITUDBLOQUEOSARLAFT.BTN_GESTIONAR' | translate}}"
                              pButton (click)="gestionarSolicitud(row)"></button>
                    </div>
                    <div class="text-center" [hidden]="!cargandoInfoSolicitud">
                        <i class="fa fa-refresh fa-spin fa-fw"></i>
                        <span>{{ 'LBL_CARGANDO' | translate}}...</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-dialog id="dlgGestionarBloqueoSarlaft"
          [draggable]="false"
          [resizable]="false"
          [closable]="false"

          [contentStyle]="{'width':'600px'}"
          [(visible)]="formContinuarProcesoSarlaft.showDlgContinuarProceso"
          *ngIf="formContinuarProcesoSarlaft.showDlgContinuarProceso"
          [modal]="true">
  <div class="grid form-group">
    <div class="col-12 md:col-12" *ngIf="formContinuarProcesoSarlaft.listaUnidadesCredito.length > 0 && solicitudHistorico">
      <p-tabView (onChange)="cambioTabView($event)">
        <p-tabPanel header="{{unidad.tipoVinculacion}}" *ngFor="let unidad of formContinuarProcesoSarlaft.listaUnidadesCredito; let j = index"
                    [selected]="j === 0" >
          <div class="grid dashboard">
            <div class="col-12">
              <div class="user-card">
                <div class="user-card-header">
                  <img alt="" src="assets/layout/images/dashboard/user-card-header.jpg" style="width: 100%;"/>
                </div>
                <div class="user-card-content">
                  <img alt="" [src]="unidad.rutaAdjuntoRiesgo ? unidad.rutaAdjuntoRiesgo : '/assets/images/perfil/avatar.jpg'"/>
                  <div class="user-card-name">
                    <span style="font-size: 1.3rem;">{{unidad.nombreCompleto }}</span>
                  </div>
                  <div class="user-detail">
                    <div class="grid">
                      <div class="col-12 md:col-6 lg:col-12">
                        <label >
                          <strong>{{unidad.tipoDocumento}}: </strong>{{unidad.numeroDocumento}}
                        </label>
                      </div>

                      <div class="col-12 md:col-6 lg:col-12">
                        <label >
                          <strong>{{ 'SOLICITUDBLOQUEOSARLAFT.LBL_RESPUESTA' | translate }}: </strong>{{unidad.integracionObj.message}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 md:col-12 lg:col-12 text-center div-form">
              <label style="font-weight: bold;">{{ 'SOLICITUDBLOQUEOSARLAFT.LBL_OBSERVACION' | translate }}</label>
              <textarea pInputTextarea rows="2" id="observacionContinuar"
                        name="observacionContinuar"
                        autocomplete="off"
                        [(ngModel)]="unidad.observacion"
                        maxlength="200"
                        capitalize-reactive
              ></textarea>
            </div>
            <div class="col-12 md:col-12 lg:col-12 text-center div-form">
              <label style="font-weight: bold;">{{ 'SOLICITUDBLOQUEOSARLAFT.LBL_ADJUNTO' | translate }}</label>
              <div  [hidden]="formContinuarProcesoSarlaft.listaUnidadesCredito[j] && formContinuarProcesoSarlaft.listaUnidadesCredito[j].idAdjunto" >
                <div [hidden]="formContinuarProcesoSarlaft.uploadingFile">
                  <p-fileUpload name="file" url="{{svcThUrl}}" [auto]="false" class="upload-avatar"
                                chooseLabel="{{'LBL_SUBIR' | translate}}"
                                (onBeforeUpload)="onBeforeSend($event, j)" mode="basic"
                                (onValidSelect)="onSelect($event, $event.files, j)"
                                (onUpload)="onUpload($event, j)" fSize accept="{{ftype}}"
                  ></p-fileUpload>
                </div>
                <div *ngIf="formContinuarProcesoSarlaft.uploadingFile">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_CARGANDO' | translate }}</span>
                </div>
                <div class="p-message p-messages-error p-corner-all" *ngIf="formContinuarProcesoSarlaft.submittedContinuarProceso && !formContinuarProcesoSarlaft.listaUnidadesCredito[j].idAdjunto">
                  {{ 'LBL_ADJUNTO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                </div>
              </div>
              <div *ngIf="formContinuarProcesoSarlaft.listaUnidadesCredito[j].idAdjunto">
                <div class="grid form-group">
                  <div class="md:col-offset-3"></div>
                  <div class="col-5 md:col-5 lg:col-5">
                    <label>{{formContinuarProcesoSarlaft.listaUnidadesCredito[j].nomArchivo}}</label>
                  </div>
                  <div class="col-1 md:col-1 lg:col-1">
                    <i class="fa fa-trash fa-2x" style="color: red;cursor: pointer;" (click)="eliminarAdjunto(j)"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </p-tabPanel>
      </p-tabView>
    </div>

    <div class="col-12 md:col-12 text-center" *ngIf="formContinuarProcesoSarlaft.listaUnidadesCredito.length === 0 && solicitudHistorico">
      <label>{{ 'MSG_NOHAYREGISTROS' | translate}}</label>
    </div>
    <div class="col-12 md:col-12 text-center" *ngIf="formContinuarProcesoSarlaft.listaUnidadesCredito.length > 0 && !solicitudHistorico">
      <label>{{ 'SOLICITUDBLOQUEOSARLAFT.MSG_SINESTADOHISTORICOPARACAMBIAR' | translate}}</label>
    </div>
    <div class="col-12 md:col-12 text-center" *ngIf="formContinuarProcesoSarlaft.listaUnidadesCredito.length === 0 && !solicitudHistorico">
      <label>{{ 'MSG_NOHAYREGISTROS' | translate}}</label>
    </div>
  </div>

  <div class="grid form-footer-buttons">
    <div class="lg:col-12 md:col-12 col-12 text-center" *ngIf="!continuandoProceso">
      <a (click)="cerrarDlgGestionarSarlaft()" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
      <button icon="fa fa-ban" label="{{'SOLICITUDBLOQUEOSARLAFT.BTN_DENEGAR' | translate }}"
              pButton class="btn-danger" (click)="abrirModalDenegar()"></button>
      <button type="button" pButton icon="fa fa-unlock-alt" (click)="continuarProceso()" [disabled]="formContinuarProcesoSarlaft.listaUnidadesCredito.length === 0 || !solicitudHistorico"
              label="{{ 'SOLICITUDBLOQUEOSARLAFT.BTN_CONTINUARPROCESO' | translate }}"></button>
    </div>
    <div class="col-12 md:col-12 lg:col-12 text-center" *ngIf="continuandoProceso">
      <i class="fa fa-refresh fa-spin fa-fw"></i>
      <span>{{ 'SOLICITUDBLOQUEOSARLAFT.LBL_GESTIONANDO' | translate}}...</span>
    </div>
  </div>
</p-dialog>

<p-dialog [draggable]="false"
          [resizable]="false"
          [closable]="false"

          [(visible)]="showDlgDenegar"
          *ngIf="showDlgDenegar"
          [contentStyle]="{'width':'600px'}"
          header="{{ 'SOLICITUDBLOQUEOSARLAFT.LBL_SELECCIONARCAUSAL' | translate}}"
          [modal]="true">
  <div class="grid" *ngIf="loadingCausalDlg">
    <div class="col-12 md:col-12 lg:col-12 text-center">
      <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
      <span>{{'LBL_PROCESANDO' | translate }}</span>
    </div>
  </div>

  <div class="grid form-group" *ngIf="!loadingCausalDlg">
    <div class="col-12 md:col-12 lg:col-12">
      <form [formGroup]="formDenegarSolicitud" (ngSubmit)="preguntarDenegarSolicitud()" novalidate id="fCausalLiberacion" name="fCausalLiberacion">
        <div class="grid form-group">
          <div class="col-12 md:col-12 lg:col-12">
            <div class="div-form">
              <label>* {{ 'SOLICITUDBLOQUEOSARLAFT.LBL_CAUSAL' | translate }}</label>
              <p-dropdown disableTab  id="idCausalSolicitud" name="nomCausalSolicitud" [options]="listaCausalesSolicitud"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                           formControlName="idCausalSolicitud"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="fD.idCausalSolicitud.invalid && denegarSubmitted">
                {{ 'SOLICITUDBLOQUEOSARLAFT.LBL_CAUSAL' | translate}} {{ 'LBL_REQUERIDO' | translate }}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-12">
            <div class="div-form">
              <label>{{ 'SOLICITUDBLOQUEOSARLAFT.LBL_OBSERVACION' | translate }}</label>
              <textarea pInputTextarea rows="2" id="observacion"
                        name="observacion"
                        autocomplete="off"
                        formControlName="observacion"
                        maxlength="200"
                        capitalize-reactive
              ></textarea>
            </div>
          </div>
        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!savingCausal">
              <a (click)="cancelarDenegar(formDenegarSolicitud.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
              <button icon="fa fa-unlock-alt "
                      label="{{'SOLICITUDBLOQUEOSARLAFT.BTN_DENEGAR' | translate }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="savingCausal">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>


<p-confirmDialog #cd key="cancelar">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
